window.addEventListener('load', function() {
  // Loading spinner - hide on window load
  var spinnerFullscreen = document.querySelector('.spinner-fullscreen');
  if (spinnerFullscreen) {
    spinnerFullscreen.style.display = 'none';
  }

  // loading spinner - show on form submit
  var paymentForms = document.querySelectorAll('.fw-payment-wrapper form');
  paymentForms.forEach(function(form) {
    if (form.dataset.blockLoadingSpinner === 'true') { return; }

    form.addEventListener('submit', function() {
      if (spinnerFullscreen) {
        spinnerFullscreen.style.display = 'block';
      }
    });
  });

  // Toggle payment method important info
  document.querySelectorAll(".toggle-pm-description").forEach(function(element) {
    element.addEventListener("click", function() {
      var pmId = this.id;
      var clickedPm = this;

      document.querySelectorAll(".payment-method-description").forEach(function(descElement) {
        var descriptionId = descElement.id;

        if (descriptionId === pmId) {
          // Toggle important info div
          descElement.style.display = (descElement.style.display === 'none' || descElement.style.display === '') ? 'block' : 'none';

          // Toggle the icons
          clickedPm.children[1].style.display = (descElement.style.display === 'none') ? 'inline-block' : 'none'; // down icon
          clickedPm.children[2].style.display = (descElement.style.display === 'none') ? 'none' : 'inline-block'; // up icon
        }
      });
    });
  });

  // Floating label effect of the forms
  var floatingLabelStyle = function(label) {
    label.style.fontSize = '12px';
    label.style.top = '6px';
  };

  var resetLabelStyle = function(label) {
    label.style.fontSize = '14px';
    label.style.top = '16px';
  };

  var setlabelStyle = function(control, label) {
    if (control.value) {
      floatingLabelStyle(label);
    } else {
      resetLabelStyle(label);
    }
  };

  var setWrapper = function(wrapper, focus) {
    // get input that is not a file upload
    var inputField = wrapper.querySelector("input:not([type='file'])");
    // var selectField = wrapper.querySelector("select");
    var label = wrapper.children[0].firstElementChild;

    // set label style for all selects
    Array.from(document.querySelectorAll('select')).forEach(function(select) {
      setlabelStyle(select, label);
    });

    // if we are focused on the field - set floating
    if (focus) {
      floatingLabelStyle(label);
    } else if (inputField) {
      // otherwise set label style according to input val
      setlabelStyle(inputField, label);
    }
  };

  // listen in to focus and change events
  Array.from(document.querySelectorAll('.fw-input-wrapper')).forEach(function(wrapper) {
    wrapper.addEventListener('focusin', function() {
      setWrapper(wrapper, true);
    });

    wrapper.addEventListener('focusout', function() {
      setWrapper(wrapper, false);
    });

    wrapper.addEventListener('change', function() {
      setWrapper(wrapper);
    });
  });

  // initialise all the wrappers
  Array.from(document.querySelectorAll('.fw-input-wrapper')).forEach(function(wrapper) {
    setWrapper(wrapper);
  });

  // Remove validation error message
  var removeError = function(event) {
    var context = event.target;

    // remove error class from parent
    var parentDiv = context.closest('.error');
    if (!parentDiv) return;
    parentDiv.classList.remove('error');

    // remove siblings / nearest child help-inline span
    parentDiv.querySelectorAll('span.help-inline').forEach(function(el) { el.remove(); });

    // remove event listeners
    context.removeEventListener('change', removeError);
    context.removeEventListener('keyup', removeError);
  };

  Array.from(document.querySelectorAll('.error input, .error select')).forEach(function(input) {
    input.addEventListener('change', removeError);
    input.addEventListener('keyup', removeError);
  });
});
